import React from 'react';
import './style.less';

function Sheet(props) {
    const { title, infoList, table, planList, descList, className } = props;
    const descListLen = descList.length;
    return (
        <div className={`assessmentSheet ${className}`}>
            <h2 className="title">{title}</h2>
            <div className="info">
                <ul className="info-list">
                    {
                        infoList.map((i, index) => (
                            <li key={index} className="info-item">
                                <div className="info-label">{i.label}:</div>
                                <div className="info-content">{i.value}</div>
                            </li>
                        ))
                    }
                </ul>
            </div>
            <div className="table">
                {table}
            </div>
            <div className="plan">
                <ul className="plan-list">
                    {
                        planList.map((i, index) => (
                            <li key={index} className="plan-item">
                                <div className="plan-title">{i.label}</div>
                                <div className="plan-content">{i.value}</div>
                            </li>
                        ))
                    }
                </ul>
            </div>
            <div className="desc">
                <p className="desc-text">说明:</p>
                {
                    descList.map((i, index) => <p key={i} className="desc-text">{index + 1}. {i}{index < descListLen - 1 ? ';' : '。'}</p>)
                }
            </div>
        </div>
    );
}

export default Sheet;


// WEBPACK FOOTER //
// ./src/components/teachingManagement/Component/Sheet.js